import { ApplicationModel } from './application.model';
import { DipModel } from './dip.model';

export class DocUploadModal {
    arnNo: string;
    isFrom: any;
    private docRec: DocRec[];

    constructor(data?){
        if(data){
            this.arnNo = data.arnNo;
            this.isFrom = data.isFrom;
            this.docRec =  data.docRec.map((docRec)=>{
                return new DocRec(docRec);
            });
        }
    }

    getDocCategoryList(){
        return this.docRec || [];
    }

    isAllDocumentUploaded(){
            let documents = this.getDocCategoryList();
            let totalDocumentLength = documents.length;
            let uploadedDocuments = documents.filter((document: DocRec)=>{
                return document.documentSelected && document.documentSelected.uploadedFiles.length;
            });
    
            return totalDocumentLength == uploadedDocuments.length;
    }

   


} 


export class DocRec {
    sectionHeading: string;
    docInfo: DocumentInfo[];
    documentSelected: DocumentInfo;
    constructor(data?){
        if(data){
            this.sectionHeading = data.sectionHeading;
            this.docInfo = data.docInfo.map((docRec)=>{
                return new DocumentInfo(docRec);
            });
            if(this.docInfo.length == 1){
                this.documentSelected = this.docInfo[0];

            } else if(this.docInfo.length > 1){
                const documentSelected = this.docInfo.filter((doc)=>{
                    return doc.uploadedFiles && doc.uploadedFiles.length;
                })[0];
                if(documentSelected){
                  this.documentSelected = documentSelected;
                }
            
            }


        }
    }

    

    
}

export class DocumentInfo {
    docName: string;
    docCode: string;
    docLimit: string;
    docIndex: DocObj[]; 
    uploadedFiles: string[] = [];
    files: any[] = [];
    docUploadMsg: string = '';
    index:string;
    constructor(data?){
        if(data){
            this.docName = data.docName;
            this.docCode = data.docCode;
            this.docLimit = data.docLimit;
            this.docIndex = data.docIndex.map((doc)=>{
                const docObj = new DocObj(doc);
                if(docObj.fileNetId){
                    this.files.push(docObj)
                    this.uploadedFiles.push(docObj.index);
                }
                return docObj;
            });
          

        }
    }
    
}

export class DocObj {
    index: string;
    fileContent: any;
    fileNetId: any;
    fileName: string;
    file: any;
    image: any;
    isCameraImage: boolean;
    pdfSrc: string;
    fileType: string;
    isActive: boolean;
    constructor(data){
        if(data){
            this.index = data.index;
            this.fileContent = data.fileContent;
            this.fileNetId = data.fileNetId;
            this.fileName = data.name;
            let file = {
                name: this.fileName
            }
            if(this.fileNetId){
                this.image = '/content/dam/hsbc/ae/uaeapplication/images/pdf_icon.jpg';
               
                this.pdfSrc = this.getBase64String(this.fileContent);
               // docObj.fileType = this.getFileType(file.type);
               
            }
            this.file = file;
        }
    }
    getBase64String (imgSrc) {
        return 'data:application/pdf;base64,' + imgSrc;
    };
}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/models/doc-upload.model.ts